module.exports = __webpack_public_path__ + "img/liebe-gerda.png";